import classnames from "classnames";
import styles from "./events.module.scss";
import SbEditable from "storyblok-react";
import {
  EventPricingCardStoryblok,
  EventPricingCardsStoryblok,
} from "@/types/component-types-sb";

interface Props {
  className?: string;
  blok: EventPricingCardsStoryblok;
}

const EventPricingCards = (props: Props) => {
  const {
    blok: { cards },
    className,
  } = props;
  const classes = classnames(styles.pricingCards, className);
  return cards ? (
    // @ts-expect-error
    <SbEditable content={props.blok}>
      <div className={classes}>
        {cards.map((blok) => (
          <EventPricingCard key={blok._uid} {...blok} />
        ))}
      </div>
    </SbEditable>
  ) : null;
};

const EventPricingCard = (props: EventPricingCardStoryblok) => {
  const {
    title = "Title",
    copy = "copy",
    price = "on request",
    per,
    className,
  } = props;

  const classes = classnames(styles.card, className);

  return (
    <div className={classes}>
      <h4>{title}</h4>
      <hr className={styles.cardDivider} />
      <p className={"ef-text-para -light -small u-mt-m"}>{copy}</p>
      <hr className={styles.cardDivider} />
      <p className={styles.price}>{price}</p>
      {per ? <p className={styles.per}>{per}</p> : null}
    </div>
  );
};

export default EventPricingCards;
